export enum KYCStatuses {
  // noinspection JSUnusedGlobalSymbols
  NOT_ALLOWED = 'Not allowed',
  NO_KYC = 'No KYC',
  PENDING = 'pending',
  LEVEL_1 = 'KYC level 1',
  LEVEL_2 = 'KYC level 2',
}
